module.exports = __webpack_public_path__ + "static/powerpage_heading-07094d0ed63e8c67d63139cfa30b333c.png";